/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/shipping-and-fulfillment/fulfillmentevent
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyFulfillmentEventKey,
  ShopifyFulfillmentEventToFulfillmentKey,
  ShopifyFulfillmentEventToOrderKey,
  ShopifyFulfillmentEventToShopKey,
  ShopifyFulfillmentKey,
  ShopifyOrderKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyFulfillmentEventKey,
  "2022-01": {
    name: "Shopify Fulfillment Event",
    fields: [
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "address1" } },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "city" } },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "country" } },
      },
      {
        name: "Estimated Delivery At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "estimated_delivery_at" } },
      },
      {
        name: "Fulfillment",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToFulfillmentKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_id" } },
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
        },
      },
      {
        name: "Happened At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "happened_at" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Latitude",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "latitude" } },
      },
      {
        name: "Longitude",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "longitude" } },
      },
      {
        name: "Message",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "message" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "province" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Status",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "zip" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifyFulfillment
    syncConfig: { type: "inherit" },
  },
  "2024-04": {
    syncConfig: {
      type: "custom",
      resource: "fulfillmentEvents",
    },
  },
  "2025-04": {
    fields: [
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToShopKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "shop_id",
            graphQLFieldKey: "shop",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
      {
        name: "Address 1",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "address1",
            graphQLFieldKey: "address1",
            protectedCustomerData: ["address"],
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "City",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "city",
            graphQLFieldKey: "city",
            protectedCustomerData: ["address"],
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Country",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "country",
            graphQLFieldKey: "country",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Estimated Delivery At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "estimated_delivery_at",
            graphQLFieldKey: "estimatedDeliveryAt",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Fulfillment",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToFulfillmentKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "fulfillment_id",
            graphQLFieldKey: "fulfillmentId",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyFulfillmentKey,
        },
      },
      {
        name: "Happened At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "happened_at",
            graphQLFieldKey: "happenedAt",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id", availableInWebhook: ["fulfillment_events/create"] },
        },
      },
      {
        name: "Latitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "latitude",
            graphQLFieldKey: "latitude",
            protectedCustomerData: ["address"],
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Longitude",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "longitude",
            graphQLFieldKey: "longitude",
            protectedCustomerData: ["address"],
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Message",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "message",
            graphQLFieldKey: "message",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentEventToOrderKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "order_id",
            graphQLFieldKey: "orderId",
            skipGraphQLSelection: true,
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Province",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "province",
            graphQLFieldKey: "province",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ATTEMPTED_DELIVERY" },
            { name: "CONFIRMED" },
            { name: "DELAYED" },
            { name: "DELIVERED" },
            { name: "FAILURE" },
            { name: "IN_TRANSIT" },
            { name: "LABEL_PRINTED" },
            { name: "LABEL_PURCHASED" },
            { name: "OUT_FOR_DELIVERY" },
            { name: "READY_FOR_PICKUP" },
          ],
        },
      },
      {
        name: "ZIP Code",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "zip",
            graphQLFieldKey: "zip",
            availableInWebhook: ["fulfillment_events/create"],
            protectedCustomerData: ["address"],
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_sublist",
      parent: "order.fulfillments",
      resource: "fulfillment.events",
      additionalFields: ["fulfillmentId: id", "orderId:order { id }"],
    },
  },
  "2025-10": {
    fields: [
      {
        name: "Status",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["fulfillment_events/create"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ATTEMPTED_DELIVERY" },
            { name: "CARRIER_PICKED_UP" },
            { name: "CONFIRMED" },
            { name: "DELAYED" },
            { name: "DELIVERED" },
            { name: "FAILURE" },
            { name: "IN_TRANSIT" },
            { name: "LABEL_PRINTED" },
            { name: "LABEL_PURCHASED" },
            { name: "OUT_FOR_DELIVERY" },
            { name: "READY_FOR_PICKUP" },
          ],
        },
      },
    ],
  },
};

export const ShopifyFulfillmentEvent = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
